import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api, setToken } from '../api';
import Footer from '../components/Footer';

export default function Login() {
  const [username, setUsername] = useState('admin');
  const [password, setPassword] = useState('Admin@123456');
  const [err, setErr] = useState('');
  const nav = useNavigate();

  const submit = async (e: any) => {
    e.preventDefault();
    try {
      const d = await api('/auth/login', {
        method: 'POST',
        body: JSON.stringify({ username, password }),
      });
      setToken(d.token);
      nav('/dashboard');
    } catch (e: any) {
      setErr(e.message);
    }
  };

  return (
    <div className="h-full flex items-center justify-center bg-gradient-to-br from-brand-700 to-brand-900 px-4">
      <form onSubmit={submit} className="bg-white p-7 rounded-2xl shadow-xl w-full max-w-sm space-y-5">
        <div className="text-center">
          <div className="text-3xl mb-1">📊</div>
          <h1 className="text-xl font-bold">财务ERP 登录</h1>
          <p className="text-xs text-slate-400 mt-1">移动办公 · 业务报货 · 考勤打卡</p>
        </div>
        <input
          className="w-full border border-slate-200 rounded-lg px-4 py-3 text-base focus:ring-2 focus:ring-brand-500 outline-none"
          placeholder="用户名"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
        <input
          type="password"
          className="w-full border border-slate-200 rounded-lg px-4 py-3 text-base focus:ring-2 focus:ring-brand-500 outline-none"
          placeholder="密码"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        {err && <div className="text-red-500 text-sm text-center">{err}</div>}
        <button className="w-full bg-brand-600 text-white rounded-lg py-3 text-base font-bold hover:bg-brand-700 active:scale-95 transition">
          登 录
        </button>
        <div className="text-xs text-slate-400 text-center">默认账号 admin / Admin@123456</div>
        <div className="text-xs text-slate-400 text-center">
          <a href="/portal/login" className="text-brand-600 underline">我是客户？前往自助报货门户</a>
        </div>
      </form>
      <Footer variant="dark" />
    </div>
  );
}
